import React, { useCallback, useState } from 'react'
import { images } from '../../../../assets'

export const BusinessRegistrationFile = ({ register, clearErrors, setError, errors, setValue, getValues }) => {
  const [count, setCount] = useState(0)
  const onChange = newFiles => {    
    const files = [...(getValues('upload_file') || [])]
    for (const file of newFiles) {
      //   console.log(file);
      const regex = /(jpg|jpeg|png|pdf)$/i
      if (!regex.exec(file.type)) {
        continue
      }

      files.push(file)
    }

    const v = files && files.length > 0 ? files : null
    setValue('upload_file', v)
    if (v) {
      clearErrors('upload_file')
    }
    setCount(count + 1) // forceupdate
  }

  const handleDrop = useCallback(event => {
    event.preventDefault()
    const files = event.dataTransfer.files
    if (files && files.length > 0) {
      onChange(files)
    }
  }, [])

  const handleDragOver = useCallback(event => {
    event.preventDefault()
  }, [])

  return (
    <div className="upload-file-container" onDrop={handleDrop} onDragOver={handleDragOver}>
      <label htmlFor="upload_file">
        <span>사업자 등록증</span>
      </label>
      <input
        multiple
        name="upload_file"
        id="upload_file"
        type="file"
        className="display_none"
        // {...register('upload_file', { onChange })}
        onChange={e => onChange(e?.target?.files)}
        accept=".jpg, .png, .pdf"
      />
      <label className={'upload-area ' + (errors.upload_file ? 'error' : '')} htmlFor="upload_file">
        <img src={images.upload} alt="upload" />
        <p>
          여기에 파일을 올리거나 클릭하여 사업자등록증을 첨부해주세요. <br />
          jpg, png, pdf 형식의 파일을 첨부할 수 있습니다.
        </p>
      </label>
      <p className="caution">{errors.upload_file?.message}</p>
      <div className="files-row">
        {(getValues('upload_file') ?? []).map(file => (
          <div key={file.name}>
            <span>{file.name}</span>
            <button
              type="button"
              onClick={() => {
                const ls = getValues('upload_file').filter(f => f !== file)

                setValue('upload_file', ls && ls.length > 0 ? ls : null)
                onChange([])
              }}>
              삭제
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}
